module.exports = __webpack_public_path__ + "static/media/squirrel.506970c5.jpg";